<template>
    <vFlowSourceConfigComponent :postList="postList" v-if="flag"></vFlowSourceConfigComponent>
</template>
<script>
import vFlowSourceConfigComponent from '../../listComponent/basicdata/flowSourceConfig/flowSourceConfigComponent.vue';
export default {
    name: 'flowSourceConfig',
    components: {
        vFlowSourceConfigComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                account_rid: true,
                account_code: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>